export class AuthException extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthException";
  }
}